const feeRateOptionList = [];
for (let i = 0; i <= 100; i += 10) {
    feeRateOptionList.push(i);
}
export default feeRateOptionList.map((time) => ({
    text: String(time),
    value: time,
}));
